<template>
  <form @submit.prevent="zoneAction">
    <div class="mb-3">
      <label>Zone</label>
      <multiselect v-model="assignment.zone" :options="zones.objects" :class="{
                        'is-invalid': v$.assignment.zone.$error,
                  }" class="multiselect-height-3" placeholder="Select one" label="name" track-by="name"></multiselect>
      <p
          v-for="error of v$.assignment.zone.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Day of the Week</label>
      <multiselect v-model="assignment.deliveryDay" :options="deliveryDays.objects" :class="{
                        'is-invalid': v$.assignment.deliveryDay.$error,
                  }" class="multiselect-height-3" placeholder="Select required" label="weekday" track-by="weekday"></multiselect>
      <p
          v-for="error of v$.assignment.deliveryDay.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in SettingsErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="lg" class="py-3 h3" disabled v-if="SettingsLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-3 h3 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import Multiselect from "vue-multiselect";
import {ALL_DELIVERY_DAYS, ALL_DELIVERY_ZONES} from "@/gql/system-settings";
import {mapGetters} from "vuex";

export default {
name: "day-zone-form",
  components: {Multiselect},
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      assignment: this.selected_zone_assignment,
      deliveryDays: {
        objects: []
      },
      zones: {
        objects: []
      }
    }
  },
  props: {
    selected_zone_assignment: {
      type: Object,
      default(){
        return {
          zone: '',
          deliveryDay: '' ,
        }
      }
    },
    button_text: {type: String}
  },
  apollo: {
    deliveryDays: {
      query: ALL_DELIVERY_DAYS,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    },
    zones: {
      query: ALL_DELIVERY_ZONES,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    }
  },
  computed: {
    ... mapGetters({
      SettingsLoading: 'settings/settingsLoading',
      SettingsErrors: 'settings/settingsErrors'
    }),
  },
  validations () {
    return {
      assignment: {
        zone: {required},
        deliveryDay: {required},
      }
    }
  },
  methods: {
    async zoneAction(){
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        zone: this.assignment.zone.publicId,
        deliveryDay: this.assignment.deliveryDay.publicId
      }

      this.$emit('zoneAction', data)
      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
